import { config } from '../core/utils/config';

export class Urls {
  static apiBaseUrl = config.apiUrl;
}
